var s1 = require('../../assets/images/our-services/large/s1.jpg');
var s2 = require('../../assets/images/our-services/large/s2.jpg');
var s3 = require('../../assets/images/our-services/large/s3.jpg');
var s4 = require('../../assets/images/our-services/large/s4.jpg');
var s5 = require('../../assets/images/our-services/large/s5.jpg');
var s6 = require('../../assets/images/our-services/large/s6.jpg');
const DataSliderHomeFacility = [
  {
    id: 1,
    src: s1,
	title:"Scholarship Facility",
	link:'/about',
	icon:<span className="flaticon-envelope"></span>,
	description:"Every year aspiring school students eagerly seek opportunities to secure their educational dreams.",
    alt: "Scholarship Facility",
  },
  {
    id: 2,
    src: s2,
	title:"Child Extra Activity",
	link:'/about',
	icon:<span className="flaticon-smartphone"></span>,
	description:"Extra-curricular activities will help your child improve academically, become a good team player, and develop confidence. ",
    alt: "Child Extra Activity"
  },{
    id: 3,
    src: s3,
	title:"Books & Library",
	link:'/library',
	icon:<span className="flaticon-placeholder"></span>,
	description:"A school library is much more than a repository of books.",
    alt: "Books & Library"
  },{
    id: 4,
    src: s4,
	title:"Regular Classes",
	link:'/classrooms',
	icon:<span className="flaticon-placeholder"></span>,
	description:"A regular school facilitates regularity in the students as they have to attend classes regularly for attendance.",
    alt: "Regular Classes"
  },{
    id: 5,
    src: s5,
	title:"Educational Tours",
	link:'/tour',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Educational trips involve group activities and require students to work together, which helps them develop teamwork skills and social skills. ",
    alt: "Educational Tours"
  },{
    id: 6,
    src: s6,
	title:"Sport Clubs",
	link:'/sports',
	icon:<span className="flaticon-placeholder"></span>,
	description:"Sports clubs encourage students to take on accountability and responsibility.",
    alt: "Sport Clubs",
  }
];
export default DataSliderHomeFacility;